export type DepositBalance = { totalAmount: number }

/** Normalize API/store deposit shapes into a numeric balance. */
export function normalizeDeposit(raw: unknown): DepositBalance {
  if (raw == null) return { totalAmount: 0 }
  if (typeof raw === 'number' || typeof raw === 'string') {
    const n = Number(raw)
    return { totalAmount: Number.isFinite(n) ? n : 0 }
  }
  if (typeof raw === 'object' && raw !== null && 'totalAmount' in raw) {
    const n = Number((raw as { totalAmount: unknown }).totalAmount)
    return { totalAmount: Number.isFinite(n) ? n : 0 }
  }
  return { totalAmount: 0 }
}

/** Prefer discounted total when present and positive. */
export function getDueAmount(amount: unknown, amountWithDiscount: unknown): number {
  const discounted = Number(amountWithDiscount)
  if (Number.isFinite(discounted) && discounted > 0) return discounted
  const full = Number(amount)
  return Number.isFinite(full) ? full : 0
}

export type DepositPayState = 'loading' | 'need_login' | 'enough' | 'short'

export function getDepositPayState(opts: {
  userObject: { deposit?: unknown } | null | undefined
  amount: unknown
  amountWithDiscount: unknown
  depositLoaded?: boolean
}): DepositPayState {
  const { userObject, amount, amountWithDiscount, depositLoaded } = opts
  if (!userObject) return 'need_login'
  if (depositLoaded === false || (depositLoaded !== true && userObject.deposit === undefined)) {
    return 'loading'
  }
  const due = getDueAmount(amount, amountWithDiscount)
  if (!(due > 0)) {
    // Amounts start at 0 until /order/cost resolves — treat as loading, not blank.
    return 'loading'
  }
  const balance = normalizeDeposit(userObject.deposit).totalAmount
  return balance >= due ? 'enough' : 'short'
}
